import { render, staticRenderFns } from "./EditDefaultModal.vue?vue&type=template&id=562f5052&scoped=true&lang=pug"
import script from "./EditDefaultModal.vue?vue&type=script&lang=js"
export * from "./EditDefaultModal.vue?vue&type=script&lang=js"
import style0 from "./EditDefaultModal.vue?vue&type=style&index=0&id=562f5052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562f5052",
  null
  
)

export default component.exports